import type { Layer, LayerId } from '../../model/types';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { usePieceSelector } from '../../model/piece-context';
import { findLayerById } from '../../model/nested-layers';

/** The layerId of the currently selected canvas object, if any. */
export const useSelectedLayerId = (): LayerId | null => {
  const { selectedObject } = useEditorCanvas();
  return (selectedObject?.layerId as LayerId | undefined) ?? null;
};

/**
 * The model layer behind the current selection, read from the model — not from Fabric.
 * Resolves group children too (e.g. a pill selected inside a chain by drilling in).
 */
export const useSelectedLayer = (): Layer | null => {
  const id = useSelectedLayerId();
  return usePieceSelector(m => (id ? findLayerById(m, id) : null));
};
